export default "__VITE_ASSET__P0fLr1da__"